import { render, staticRenderFns } from "./ShippingTab.vue?vue&type=template&id=71e1ea7a&scoped=true&"
import script from "./ShippingTab.vue?vue&type=script&lang=js&"
export * from "./ShippingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1ea7a",
  null
  
)

export default component.exports